const layout = () => import('@/views/layout')
const handover = () => import('@/views/handover/handover')
const handoverRecord = () => import('@/views/handover/handoverRecord')
const handoverDetail = () => import('@/views/handover/handoverDetail')

export default [
  {
    path: '/handover',
    name: 'handover',
    redirect: '/handover/handoverHome',
    component: layout,
    meta: {
      title: '交接班管理',
      icon: 'work.png',
      index: 5
    },
    children: [
      { path: 'handoverHome', name: 'handoverHome', component: handover,  meta: { title: '交接班操作', id: '1621476220', scrollToTop: true } },
      { path: 'handoverRecord', name: 'handoverRecord',componentName: 'handover_handoverRecord', component: handoverRecord, meta: { title: '交接班记录', id: '1621476229', scrollToTop: true } },
      { path: 'handoverDetail', hidden: true, name: 'handoverDetail', component: handoverDetail, meta: { title: '交接班详情', scrollToTop: true } }
    ]
  }
]